module.exports = __webpack_public_path__ + "static/media/link.dad15f3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/link.svg
// module id = 628
// module chunks = 0